/* Goloka V3 search: header panel (<v3-search>) + results-page helpers.
 * Uses Shopify Predictive Search (section rendering of sections/predictive-search.liquid).
 * Synonyms are client-side only (see snippets/v3-search-config.liquid); nothing is written to the store. */
(function () {
  if (window.__v3Search) return;
  window.__v3Search = true;

  var cfg = { synonyms: {}, searchUrl: '/search', suggestUrl: '/search/suggest' };
  try {
    var node = document.getElementById('V3SearchConfig');
    if (node) cfg = Object.assign(cfg, JSON.parse(node.textContent));
  } catch (e) {}

  var DEBOUNCE = 180;
  var MIN_CHARS = 2;
  var MAX_PRODUCTS = 8;
  var GROUP_ORDER = ['queries', 'collections', 'products', 'pages'];

  function esc(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function searchHref(q) {
    return cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  /** Alternative queries for words that have a synonym (one word swapped at a time). */
  function expand(q) {
    var words = q.toLowerCase().split(/\s+/).filter(Boolean);
    var out = [];
    words.forEach(function (w, i) {
      (cfg.synonyms[w] || []).forEach(function (m) {
        var copy = words.slice();
        copy[i] = m;
        var alt = copy.join(' ');
        if (out.indexOf(alt) === -1) out.push(alt);
      });
    });
    return out.slice(0, 2);
  }

  function highlight(el, tokens) {
    var text = el.textContent;
    if (!tokens.length) return;
    var parts = text.split(new RegExp('(' + tokens.map(esc).join('|') + ')', 'ig'));
    if (parts.length < 2) return;
    el.textContent = '';
    parts.forEach(function (p, i) {
      if (!p) return;
      if (i % 2) {
        var m = document.createElement('mark');
        m.textContent = p;
        el.appendChild(m);
      } else {
        el.appendChild(document.createTextNode(p));
      }
    });
  }

  /** "Try 'sandal'" links for a raw query that maps through the synonym table. */
  function fillTry(box, q) {
    var alts = expand(q);
    box.textContent = '';
    if (!alts.length) {
      box.hidden = true;
      return;
    }
    box.appendChild(document.createTextNode('Try '));
    alts.forEach(function (alt, i) {
      if (i) box.appendChild(document.createTextNode(' or '));
      var a = document.createElement('a');
      a.className = 'v3s-try-link';
      a.href = searchHref(alt);
      a.setAttribute('data-v3s-term', alt);
      a.textContent = '“' + alt + '”';
      box.appendChild(a);
    });
    box.hidden = false;
  }

  /** Clear (reset) button visibility for any v3 search form. */
  function bindClear(form) {
    var input = form.querySelector('input[name="q"]');
    var clear = form.querySelector('.v3s__clear');
    if (!input || !clear) return;
    var sync = function () {
      clear.hidden = !input.value.length;
    };
    input.addEventListener('input', sync);
    form.addEventListener('reset', function () {
      setTimeout(function () {
        sync();
        input.focus();
      }, 0);
    });
    sync();
  }

  class V3Search extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.querySelector('[data-v3s-form]');
      this.input = this.querySelector('.v3s__input');
      this.clearBtn = this.querySelector('.v3s__clear');
      this.discover = this.querySelector('[data-v3s-discover]');
      this.live = this.querySelector('[data-v3s-live]');
      this.results = this.querySelector('[data-v3s-results]');
      this.none = this.querySelector('[data-v3s-none]');
      this.noneTitle = this.querySelector('[data-v3s-none-title]');
      this.tryBox = this.querySelector('[data-v3s-try]');
      this.status = this.querySelector('[data-v3s-status]');
      this.details = this.closest('details');
      this.panel = this.closest('.v3s');
      this.sheet = this.closest('.v3s__sheet');
      this.modal = this.closest('details-modal');
      this.cache = new Map();
      this.seq = 0;
      this.abort = null;
      this.timer = null;
      this.active = -1;
      this.query = '';

      bindClear(this.form);

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onInputKey.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('reset', this.onReset.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mousemove', this.onHover.bind(this));
      this.sheet.addEventListener('keydown', this.onSheetKey.bind(this));

      if (this.details) {
        new MutationObserver(this.onToggle.bind(this)).observe(this.details, {
          attributes: true,
          attributeFilter: ['open'],
        });
      }
      window.addEventListener('resize', this.placePanel.bind(this));
    }

    /* ---------- open / close ---------- */
    onToggle() {
      if (this.details.hasAttribute('open')) {
        this.placePanel();
        var self = this;
        requestAnimationFrame(function () {
          self.input.focus();
          if (self.input.value) self.input.select();
        });
        if (this.input.value.trim().length >= MIN_CHARS) this.run(this.input.value.trim());
      } else {
        if (this.abort) this.abort.abort();
        clearTimeout(this.timer);
        this.setActive(-1);
      }
    }

    /** Desktop: panel hangs from the header's bottom edge. Mobile is a full-screen sheet (CSS). */
    placePanel() {
      var header = document.querySelector('.section-header');
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      this.panel.style.setProperty('--v3s-top', top + 'px');
    }

    /* ---------- typing ---------- */
    onInput() {
      var q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < MIN_CHARS) {
        this.showDiscover();
        return;
      }
      this.query = q;
      this.timer = setTimeout(this.run.bind(this, q), DEBOUNCE);
    }

    onReset() {
      clearTimeout(this.timer);
      if (this.abort) this.abort.abort();
      this.showDiscover();
    }

    showDiscover() {
      this.query = '';
      this.seq++;
      this.discover.hidden = false;
      this.live.hidden = true;
      this.none.hidden = true;
      this.results.hidden = false;
      this.results.textContent = '';
      this.results.removeAttribute('aria-busy');
      this.input.setAttribute('aria-expanded', 'false');
      this.setActive(-1);
      this.status.textContent = '';
    }

    fetchOne(q, signal) {
      var key = q.toLowerCase();
      if (this.cache.has(key)) return Promise.resolve(this.cache.get(key));
      var url =
        cfg.suggestUrl +
        '?q=' +
        encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,query,page' +
        '&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      var cache = this.cache;
      return fetch(url, { signal: signal })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var payload = doc.querySelector('[data-v3s-payload]');
          cache.set(key, payload);
          return payload;
        });
    }

    run(q) {
      var self = this;
      var id = ++this.seq;
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      var signal = this.abort.signal;

      this.discover.hidden = true;
      this.live.hidden = false;
      this.none.hidden = true;
      if (!this.results.children.length) this.results.innerHTML = this.skeleton();
      this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.getAttribute('data-loading-text') || 'Loading…';

      var alts = expand(q);
      var queries = [q].concat(alts);
      Promise.all(
        queries.map(function (term) {
          return self.fetchOne(term, signal).catch(function (err) {
            if (err && err.name === 'AbortError') throw err;
            return null;
          });
        })
      )
        .then(function (payloads) {
          if (id !== self.seq) return;
          self.render(q, alts, payloads);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (id !== self.seq) return;
          self.render(q, alts, []);
        });
    }

    skeleton() {
      var row = '<div class="v3s-skel"><span class="v3s-skel__img"></span><span class="v3s-skel__lines"><i></i><i></i></span></div>';
      return '<div class="v3s-skels" aria-hidden="true">' + row + row + row + row + '</div>';
    }

    /* ---------- render ---------- */
    render(q, alts, payloads) {
      var groups = {};
      var seen = {};
      GROUP_ORDER.forEach(function (g) {
        groups[g] = null;
        seen[g] = {};
      });
      payloads.forEach(function (payload) {
        if (!payload) return;
        GROUP_ORDER.forEach(function (g) {
          var src = payload.querySelector('[data-group="' + g + '"]');
          if (!src) return;
          if (!groups[g]) {
            groups[g] = src.cloneNode(true);
            groups[g].querySelectorAll('li').forEach(function (li) {
              seen[g][li.getAttribute('data-key')] = true;
            });
            return;
          }
          var list = groups[g].querySelector('ul');
          src.querySelectorAll('li').forEach(function (li) {
            var k = li.getAttribute('data-key');
            if (seen[g][k]) return;
            seen[g][k] = true;
            list.appendChild(li.cloneNode(true));
          });
        });
      });

      if (groups.queries) {
        var qs = groups.queries.querySelectorAll('li');
        for (var j = 6; j < qs.length; j++) qs[j].remove();
      }
      if (groups.products) {
        var items = groups.products.querySelectorAll('.v3s-item');
        for (var i = MAX_PRODUCTS; i < items.length; i++) items[i].remove();
      }

      var tokens = q.toLowerCase().split(/\s+/).filter(function (w) {
        return w.length > 1;
      });
      alts.forEach(function (a) {
        a.split(/\s+/).forEach(function (w) {
          if (w.length > 1 && tokens.indexOf(w) === -1) tokens.push(w);
        });
      });
      if (groups.products) {
        groups.products.querySelectorAll('[data-v3s-mark]').forEach(function (el) {
          highlight(el, tokens);
        });
      }

      var hasAny = GROUP_ORDER.some(function (g) {
        return groups[g] && groups[g].querySelector('li');
      });
      this.results.removeAttribute('aria-busy');
      this.setActive(-1);

      if (!hasAny) {
        this.results.textContent = '';
        this.results.hidden = true;
        this.none.hidden = false;
        this.noneTitle.textContent = 'No results for “' + q + '”';
        fillTry(this.tryBox, q);
        this.input.setAttribute('aria-expanded', 'false');
        this.status.textContent = 'No results for ' + q;
        return;
      }

      this.none.hidden = true;
      this.results.hidden = false;

      var cols = document.createElement('div');
      cols.className = 'v3s-cols' + (groups.products ? '' : ' v3s-cols--single');
      var main = document.createElement('div');
      main.className = 'v3s-main';
      var side = document.createElement('div');
      side.className = 'v3s-side';

      if (alts.length) {
        var note = document.createElement('p');
        note.className = 'v3s-also';
        note.appendChild(document.createTextNode('Also showing '));
        alts.forEach(function (a, i) {
          if (i) note.appendChild(document.createTextNode(', '));
          var b = document.createElement('strong');
          b.textContent = '“' + a + '”';
          note.appendChild(b);
        });
        main.appendChild(note);
      }
      if (groups.products) main.appendChild(groups.products);

      var all = document.createElement('a');
      all.className = 'v3s-all';
      all.setAttribute('role', 'option');
      all.setAttribute('aria-selected', 'false');
      all.tabIndex = -1;
      all.href = searchHref(q);
      all.appendChild(document.createTextNode('See all results for “' + q + '” '));
      var arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      all.appendChild(arrow);
      main.appendChild(all);

      ['collections', 'queries', 'pages'].forEach(function (g) {
        if (groups[g] && groups[g].querySelector('li')) side.appendChild(groups[g]);
      });

      cols.appendChild(main);
      if (side.children.length) cols.appendChild(side);
      this.results.replaceChildren(cols);

      this.results.querySelectorAll('[role="option"]').forEach(function (opt, i) {
        opt.id = 'v3s-opt-' + i;
      });
      this.input.setAttribute('aria-expanded', 'true');

      var n = groups.products ? groups.products.querySelectorAll('.v3s-item').length : 0;
      this.status.textContent = n
        ? n + (n === 1 ? ' product' : ' products') + ' found for ' + q
        : 'Suggestions available for ' + q;
    }

    /* ---------- keyboard ---------- */
    options() {
      return Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
    }

    setActive(i) {
      var opts = this.options();
      opts.forEach(function (o) {
        o.setAttribute('aria-selected', 'false');
        o.classList.remove('is-active');
        if (o.parentElement) o.parentElement.classList.remove('is-active');
      });
      this.active = i;
      if (i < 0 || !opts[i]) {
        this.active = -1;
        this.input.removeAttribute('aria-activedescendant');
        return;
      }
      var o = opts[i];
      o.setAttribute('aria-selected', 'true');
      o.classList.add('is-active');
      if (o.parentElement) o.parentElement.classList.add('is-active');
      this.input.setAttribute('aria-activedescendant', o.id);
      o.scrollIntoView({ block: 'nearest' });
    }

    onInputKey(e) {
      var opts = this.options();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!opts.length) return;
        e.preventDefault();
        var next = this.active + (e.key === 'ArrowDown' ? 1 : -1);
        if (next >= opts.length) next = -1;
        if (next < -1) next = opts.length - 1;
        this.setActive(next);
      } else if (e.key === 'Enter') {
        if (this.active >= 0 && opts[this.active]) {
          e.preventDefault();
          window.location.href = opts[this.active].href;
        }
      } else if (e.key === 'Escape') {
        // Keep the browser from clearing the field first; details-modal closes on keyup.
        e.preventDefault();
      }
    }

    onSubmit(e) {
      var q = this.input.value.trim();
      if (!q) {
        e.preventDefault();
        return;
      }
      var opts = this.options();
      if (this.active >= 0 && opts[this.active]) {
        e.preventDefault();
        window.location.href = opts[this.active].href;
      }
    }

    onHover(e) {
      var opt = e.target.closest && e.target.closest('[role="option"]');
      if (!opt || opt.classList.contains('is-active')) return;
      var i = this.options().indexOf(opt);
      if (i > -1) this.setActive(i);
    }

    /** Wrap Tab inside the panel (the live list changes, so measure each time). */
    onSheetKey(e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        this.sheet.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'),
        function (el) {
          return el.tabIndex !== -1 && !el.hidden && el.offsetParent !== null;
        }
      );
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      var cur = document.activeElement;
      if (e.shiftKey && (cur === first || cur === this.sheet)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && cur === last) {
        e.preventDefault();
        first.focus();
      }
      e.stopPropagation();
    }

    onClick(e) {
      var term = e.target.closest && e.target.closest('[data-v3s-term]');
      if (term && this.contains(term)) {
        e.preventDefault();
        this.input.value = term.getAttribute('data-v3s-term');
        if (this.clearBtn) this.clearBtn.hidden = false;
        this.input.focus();
        this.query = this.input.value;
        clearTimeout(this.timer);
        this.run(this.input.value.trim());
        return;
      }
      var add = e.target.closest && e.target.closest('.v3-add');
      if (add && this.modal && typeof this.modal.close === 'function') {
        var modal = this.modal;
        setTimeout(function () {
          modal.close(false);
          // Dawn's close() drops the scroll lock; keep it if a quick-add dialog took over.
          if (document.querySelector('quick-add-modal[open]')) document.body.classList.add('overflow-hidden');
        }, 160);
      }
    }
  }

  if (!customElements.get('v3-search')) customElements.define('v3-search', V3Search);

  /* ---------- results page ---------- */
  function initPage() {
    document.querySelectorAll('[data-v3s-page]').forEach(bindClear);
    document.querySelectorAll('[data-v3s-try][data-term]').forEach(function (box) {
      fillTry(box, box.getAttribute('data-term'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();
})();
